import { icons } from '@assets/icons';
import { memo, useState } from 'react';

import TextField from './TextField';

const PasswordTextField = memo(({ name = 'password', label = 'Password', ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      {...props}
      name={name}
      label={label}
      type={visible ? 'text' : 'password'}
      autoComplete={props.autoComplete || 'current-password'}
      suffix={
        <button
          type="button"
          onClick={() => setVisible((prev) => !prev)}
          className="flex size-4 desktop:size-5 shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-0"
          aria-label={visible ? 'Hide password' : 'Show password'}
        >
          <img
            src={visible ? icons.eyeSlash : icons.eye}
            alt=""
            className="icon-md"
            aria-hidden="true"
          />
        </button>
      }
    />
  );
});

PasswordTextField.displayName = 'PasswordTextField';

export default PasswordTextField;
